import { Badge, Button, Modal, Space, Typography } from "antd";
import type { FC } from "react";
import type { DeployResultRow } from "../types";

const { Text } = Typography;

interface DeployResultsModalProps {
  results: DeployResultRow[] | null;
  onClose: () => void;
}

export const DeployResultsModal: FC<DeployResultsModalProps> = ({ results, onClose }) => {
  return (
    <Modal
      title="Deployment results"
      open={Boolean(results)}
      onCancel={onClose}
      footer={
        <Button type="primary" onClick={onClose}>
          Close
        </Button>
      }
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        {(results ?? []).map((result) => (
          <Space key={`${result.objectId}-${result.environmentId}`} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <Space direction="vertical" size={0}>
              <Text strong>{result.objectLabel}</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {result.environmentLabel}
                {result.message ? ` — ${result.message}` : ""}
              </Text>
            </Space>
            <Badge status={result.status === "success" ? "success" : "error"} text={result.status === "success" ? "Success" : "Failed"} />
          </Space>
        ))}
      </Space>
    </Modal>
  );
};
